import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';

import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import {
  CycleContextProvider,
  FactureContextProvider,
  LoadingContextProvider,
  ModeReglementContextProvider,
  RecuContextProvider,
} from '../Context';
import EncaissementFactureFiche from './Fiche/EncaissementFactureFiche';
import EncaissementFactureFicheBar from './Fiche/EncaissementFactureFicheBar';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip trigger={<Icon name="euro" />} message="Encaissement" position="right center" />
) : (
  <Icon name="euro" />
);

const MenuEncaissement = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_ENCAISSEMENT}
      name="Encaissement"
      icon={ICON}
      path="/encaissement"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && !disabledMenus?.encaissement}
    >
      <Feature>
        <Feature.Content>
          <LoadingContextProvider>
            <ModeReglementContextProvider autoload="régie">
              <CycleContextProvider accueil allAtOnce>
                <FactureContextProvider>
                  <RecuContextProvider defaultFilteredOnRegisseur={false} depuisDernierArrete>
                    <EncaissementFactureFicheBar />
                    <EncaissementFactureFiche />
                  </RecuContextProvider>
                </FactureContextProvider>
              </CycleContextProvider>
            </ModeReglementContextProvider>
          </LoadingContextProvider>
        </Feature.Content>
      </Feature>
    </Menu>
  );
};

export default MenuEncaissement;
